import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "features/records/components/AttributesForm"

const NewObjectButton = props => (
    <ButtonModal
        button={({ open }) => (
            <Button icon="plus" color="clear" onClick={open}>
                New Table
            </Button>
        )}
        header={() => `New Table`}
        footerClassName={css`
            justify-content: flex-end;
        `}
        footer={({ close, state }) => [
            <Button
                key="create"
                sideMargin="xsmall"
                color="success"
                onClick={() => {
                    props.onSave(state)
                    close()
                }}
            >
                Create
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
    >
        {({ setState }) => (
            <AttributesForm
                onChange={setState}
                fields={[{ type: "text", label: "Name", api_name: "name" }]}
            />
        )}
    </ButtonModal>
)
export default NewObjectButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewObjectButton.js